import { render } from "./menunavegation.vue?vue&type=template&id=861609b2&scoped=true"
import script from "./menunavegation.vue?vue&type=script&lang=js"
export * from "./menunavegation.vue?vue&type=script&lang=js"

import "./menunavegation.vue?vue&type=style&index=0&id=861609b2&scoped=true&lang=css"

import exportComponent from "C:\\CEDIS\\cedispage2.0_general_guvi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-861609b2"]])

export default __exports__